import {
  IShareDataManager,
  IAGSharedAlbumsParams,
  IAGSocailConnectionStatus,
  IAGSharedAlbumPhotosParams,
} from './ishare_data_manager';
import { AjaxHelper } from '../../http/ajax_helper';
import { AGTranslator } from '../translators/ag_translator';
import { IClientConfig } from '../data_manager/data_manager_factory';
import { Util } from '../../common_utils/util';
import { ITranslator } from '../translators/itranslator';
import { AGShareTranslator } from '../translators/ag_share_translator';

/**
 * Responsible to handle all the Aggregation flow related share API communications
 * @export
 * @class AGShareManager
 * @implements {IShareDataManager}
 */
export class AGShareManager implements IShareDataManager {
  private agTranslator: AGTranslator;
  private discoveryEndPoints: any;
  /**
   *Creates an instance of AGAlbumManager and also create an
   *instance of translator if required.
   * @param {IClientConfig} config
   * @memberof AGAlbumManager
   */
  constructor(config: IClientConfig) {
    this.agTranslator = this.getTranslatorObj(config);
    this.discoveryEndPoints = config.discoveryEndPoints;
  }
  /**
   *Method to get info of a single shared album.
   * @param {object} param
   * @returns {*}
   * @memberof AGShareManager
   */
  getSharedSingleAlbumInfo(params: IAGSharedAlbumPhotosParams): any {

    //logic to caliculate page and size parameters based on limit and skip.
    //limit and skip values are different, when compare to page and size.  
    if (params.limit) {
      params.size = params.limit;
      params.page = 0;
      if (params.skip && params.skip > 0) {
        params.page = params.skip / params.limit;
      }
    }


    let url = `${this.discoveryEndPoints.pictService}v1/gw/album/${
      params.typeOfAlbum
    }/${params.albumId}/photos?${Util.prepareParamString(params, [
      'typeOfAlbum',
      'albumId',
      'skip', 
      'limit'
    ])}`;

    

    //url = "https://gw.sf-qa.com//v1/gw/albums/shared/cluster?sortCriteria=createDate&sortOrder=asc&sourceList=google";
    const config = {
      url,
      type: 'GET',
      ignoreAToken: true,
      cacheKey: 'shared'
    };
    const promise = AjaxHelper.triggerApi(
      { requestConfig: config },
      this.agTranslator.translateSharedAlbumPhotos.bind(this.agTranslator)
    );

    return promise;
  }
  /**
   *Method to delete shared aggregated album.
   * @param {object} param
   * @returns {*}
   * @memberof AGShareManager
   */
  
  deleteSocialAlbum(params: {albumId:number}): any {
  
    let url=  `${this.discoveryEndPoints.pictService}v1/gw/share/reject/album/${params.albumId}`;

    const config = {
      url,
      type: 'DELETE',
      ignoreAToken: true,
      cacheKey: 'all'
    };

    return AjaxHelper.triggerApi({ requestConfig: config });
  }
  /**
   *Method to get the shared aggregated albums info.
   * @param {object} param
   * @returns {*}
   * @memberof AGShareManager
   */
  /* istanbul ignore next */
  getSocialAlbumsInfo(param: object): any {
    // call ajax helper do ajax
  }
  /**
   * Method is to get all sharedAlbums to the agg user and respons witll be in all
   * combinations.
   * @param {IAGSharedAlbumsParams} param
   * @param {IAGSocailConnectionStatus} status
   * @returns {*}
   * @memberof AGShareManager
   */
  getAGSocialAlbumsInfo(
    params: IAGSharedAlbumsParams,
    status: IAGSocailConnectionStatus
  ): any {
    let list = this.agTranslator.getSourceList(status);

    params.sourceList = list.paramSourceList.toString();

    const url = `${
      this.discoveryEndPoints.pictService
    }v1/gw/albums/shared/cluster?${Util.prepareParamString(params, [])}`;

    const config = {
      url,
      type: 'GET',
      ignoreAToken: true,
      cacheKey: 'owned'
    };
    const promise = AjaxHelper.triggerApi(
      { requestConfig: config },
      this.agTranslator.transformSharedAlbumResponse.bind(
        this.agTranslator,
        list.responseSourceList
      )
    );

    return promise;
  }
  getTranslatorObj(config: IClientConfig): ITranslator {
    if (!config.translator) throw new Error('translator object not present');

    return AGShareTranslator.getInstance();
  }
}
